import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['App móvil con programa de 30 días completo', 'Checklist diario interactivo', 'Barra de progreso visual', 'Biblioteca de recursos hormonales', 'Acceso de por vida desde tu celular', 'Actualizaciones incluidas'];
export function IncludesSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-120" data-mp="23ylsb6upjn2s">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-121" data-mp="1z24ufkxphuci">
        <Reveal className="text-center" data-id="element-122" data-mp="1uzrs76i64ekh">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-123" data-mp="1uyyram5w4ja9">
            Todo lo que recibes con tu acceso
          </h2>
          <p className="mt-4 text-lg text-tinta/70" data-id="element-124" data-mp="1l1u1mccu65op">
            Un acompañamiento completo, pensado para que no te falte nada.
          </p>
        </Reveal>

        <ul className="mt-10 divide-y divide-nude/60 overflow-hidden rounded-3xl border border-nude/60 bg-crema/40" data-id="element-125" data-mp="3kdwu2c3fuaei">
          {items.map((item, i) => <Reveal as="li" key={item} delay={i * 0.06} data-id="element-126" data-mp="3ug8swuwh4pld" data-mpi={i}>
              <div className="flex items-center gap-4 p-5 sm:px-7" data-id="element-127" data-mp="3uiv0uvna1744">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-rosa-light/55" aria-hidden="true" data-id="element-128" data-mp="2dr32ydjx2mu">
                  <CheckIcon className="h-4 w-4 text-rosa-dark" strokeWidth={2.6} data-id="element-129" data-mp="3piqfosbfbo7k" />
                </span>
                <span className="text-base text-tinta/90 sm:text-lg" data-id="element-130" data-mp="m0p3y82u5tc4">
                  {item}
                </span>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}